import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const CATEGORIES = ["Food", "Beverage", "Pet", "Specialty"];
export const BUYER_TYPES = ["Distributor", "Retailer", "E-Commerce Seller", "International Buyer", "Foodservice / Restaurant", "Other"];
export const STOCK_LABEL = {
  unknown: "Availability on request",
  in_stock: "In Stock",
  low_stock: "Low Stock",
  out_of_stock: "Out of Stock",
  preorder: "Pre-Order",
};
export const STOCK_STYLE = {
  unknown: "bg-slate-100 text-slate-600",
  in_stock: "bg-emerald-50 text-emerald-700",
  low_stock: "bg-amber-50 text-amber-700",
  out_of_stock: "bg-rose-50 text-rose-700",
  preorder: "bg-blue-50 text-blue-700",
};

export const fmtPrice = (v) => (v == null ? null : `$${Number(v).toFixed(2)}`);
